import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-Policy',
  templateUrl: 'companyPolicy.html'
})
export class companyPolicyComponent  implements OnInit{

  PresentDate 
  
  constructor() {
    
    let Todaydate = new Date();
    this.PresentDate=Todaydate.getFullYear()
    }
    ngOnInit(){
    
    }
    
}